import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI/colors.constant'

export const useSelectStyles = makeStyles(theme => ({
  menuItemHidden: {
    display: 'none'
  },
  selectPlaceHolder: {
    color: '#b7b9be'
  }
}))

export const useFilterChipStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 10px 4px 12px',
    borderRadius: 16,
    fontSize: 16,
    fontWeight: 500,
    borderColor: GRAY_COLORS[400],
    color: GRAY_COLORS[600],
    borderWidth: 2,
    borderStyle: 'solid',
    whiteSpace: 'nowrap'
  },
  rootSelected: {
    borderColor: PRIMARY_COLORS[400],
    color: PRIMARY_COLORS[600]
  },

  row: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10
  },
  rangeInputRight: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  rangeInputLeft: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
}))
